<template>
	<div class="social-links-container" v-if="links.length > 0">
		<span v-for="(link, index) in links" :key="index" class="social-link-item">
			<a :href="link.url" class="social-link-anchor" target="_blank" v-if="featureSet.socialIcons.icons">
				<template v-if="!featureSet.socialIcons.altIcons">
					<fa-icon v-show="link.type === 'fb'" class="faicon" :icon="['fab', 'facebook-square']"/>
				</template>
				<template v-if="featureSet.socialIcons.altIcons">
					<fa-icon v-show="link.type === 'fb'" class="faicon" :icon="['fab', 'facebook-f']"/>
				</template>
				<template v-if="!featureSet.socialIcons.altIcons">
					<fa-icon v-show="link.type === 'li'" class="faicon" :icon="['fab', 'linkedin']"/>
				</template>
				<template v-if="featureSet.socialIcons.altIcons">
					<fa-icon v-show="link.type === 'li'" class="faicon" :icon="['fab', 'linkedin-in']"/>
				</template>
				<template v-if="!featureSet.socialIcons.altIcons">
					<fa-icon v-show="link.type === 'tw'" class="faicon" :icon="['fab', 'twitter-square']"/>
				</template>
				<template v-if="featureSet.socialIcons.altIcons">
					<fa-icon v-show="link.type === 'tw'" class="faicon" :icon="['fab', 'twitter']"/>
				</template>
				<fa-icon v-show="link.type === 'ig'" class="faicon" :icon="['fab', 'instagram']"/>
				<template v-if="!featureSet.socialIcons.altIcons">
					<fa-icon v-show="link.type === 'yt'" class="faicon" :icon="['fab', 'youtube-square']"/>
				</template>
				<template v-if="featureSet.socialIcons.altIcons">
					<fa-icon v-show="link.type === 'yt'" class="faicon" :icon="['fab', 'youtube']"/>
				</template>
			</a>
			<a :href="link.url" class="social-link-anchor social-custom-icon" target="_blank" v-else>
				<div v-show="link.type === 'fb'">FB</div>
				<div v-show="link.type === 'li'">LI</div>
				<div v-show="link.type === 'tw'">TW</div>
				<div v-show="link.type === 'ig'">IG</div>
				<div v-show="link.type === 'yt'">YT</div>
			</a>
		</span>
	</div>
</template>

<script>
import staticDataLoaderMixin from '@/store/modules/staticData/static-data-loader';
import featureSetLoaderMixin from '@/store/modules/featureSet/feature-set-loader';

export default {
	name: 'SocialIcons',
	mixins: [staticDataLoaderMixin, featureSetLoaderMixin],
	data() {
		return {
			links: [],
		};
	},
	created() {
		if (this.generalSettings.social_links) {
			const linksObject = JSON.parse(this.generalSettings.social_links);
			Object.keys(linksObject).forEach((key) => {
				if (linksObject[key] && linksObject[key].trim().length > 5) {
					this.links.push({ type: key, url: linksObject[key] });
				}
			});
			// console.log(this.links);
		}
	},

};
</script>

<style src="@/styles/components/SocialIcons/SocialIcons.less" lang="less" scoped></style>
